/*
 * <grind-selector>
 * Powers the grouped "Whole Beans / Ground" bean-option experience.
 *
 * All variant selection is handled by native radios + the theme's existing
 * <variant-picker> component (which reads the checked radio per fieldset and
 * re-renders the section). List reveal and active states are pure CSS (:has()).
 *
 * The only behaviour that needs JS: clicking the "Ground" grouping button while
 * a non-ground value is selected should auto-select the first available grind so
 * a valid variant is chosen and the list opens (mirrors the AU store).
 */
if (!customElements.get('grind-selector')) {
  class GrindSelector extends HTMLElement {
    connectedCallback() {
      this.groupButton = this.querySelector('[data-grind-group]');
      if (this.groupButton && this.groupButton.dataset.bound !== 'true') {
        this.groupButton.dataset.bound = 'true';
        this.groupButton.addEventListener('click', this.onGroupClick.bind(this));
      }
    }

    get groundRadios() {
      return Array.from(
        this.querySelectorAll('[data-grind-list] input[type="radio"]')
      );
    }

    onGroupClick() {
      const radios = this.groundRadios;
      if (!radios.length) return;

      // Already on a grind — list is open, nothing to do.
      if (radios.some((radio) => radio.checked)) return;

      const target =
        radios.find((radio) => !radio.classList.contains('disabled')) ||
        radios[0];
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('grind-selector', GrindSelector);
}